/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Types_OtherInputs */

const en_admin_resources_resource_types_other = /** @type {(inputs: Admin_Resources_Resource_Types_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de_admin_resources_resource_types_other = /** @type {(inputs: Admin_Resources_Resource_Types_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

const es_admin_resources_resource_types_other = /** @type {(inputs: Admin_Resources_Resource_Types_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const fr_admin_resources_resource_types_other = /** @type {(inputs: Admin_Resources_Resource_Types_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

/** @type {(inputs: Admin_Resources_Resource_Types_OtherInputs) => LocalizedString} */
const it_admin_resources_resource_types_other = en_admin_resources_resource_types_other;

/** @type {(inputs: Admin_Resources_Resource_Types_OtherInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_types_other = en_admin_resources_resource_types_other;

/** @type {(inputs: Admin_Resources_Resource_Types_OtherInputs) => LocalizedString} */
const pl_admin_resources_resource_types_other = en_admin_resources_resource_types_other;

/** @type {(inputs: Admin_Resources_Resource_Types_OtherInputs) => LocalizedString} */
const hu_admin_resources_resource_types_other = en_admin_resources_resource_types_other;

/** @type {(inputs: Admin_Resources_Resource_Types_OtherInputs) => LocalizedString} */
const ro_admin_resources_resource_types_other = en_admin_resources_resource_types_other;

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Admin_Resources_Resource_Types_OtherInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_types_other = /** @type {((inputs?: Admin_Resources_Resource_Types_OtherInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Types_OtherInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_types_other(inputs)
	if (locale === "de") return de_admin_resources_resource_types_other(inputs)
	if (locale === "es") return es_admin_resources_resource_types_other(inputs)
	if (locale === "fr") return fr_admin_resources_resource_types_other(inputs)
	if (locale === "it") return it_admin_resources_resource_types_other(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_types_other(inputs)
	if (locale === "pl") return pl_admin_resources_resource_types_other(inputs)
	if (locale === "hu") return hu_admin_resources_resource_types_other(inputs)
	return ro_admin_resources_resource_types_other(inputs)
});
export { admin_resources_resource_types_other as "admin.resources.resource_types.other" }